import React, { useState, useContext } from "react";
import { Modal, Button, Spinner, Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { useFormik } from "formik";
import * as Yup from "yup";
import { SnackBarContext } from "../../context/SnackBarContext.jsx";
import { UpdateInspectionStatusApi } from "../../Apis/Inspection/InspectionApis";
import { fetchInspectionData } from "../../redux/slice/InspectionSlice/InspectionSlice.js";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
const validationSchema = Yup.object({
  status: Yup.string().required("Status is required"),
  reason: Yup.string().required("Reason is required"),
});

const UpdateStatusDialog = ({ open, onDeny, selectedRow }) => {
  const [loading, setLoading] = useState(false);
  const { setsnackBarData } = useContext(SnackBarContext);
  const id = selectedRow?._id;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      status: "",
      reason: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      console.log("loadig", loading);
      const payload = {
        status: values.status,
        reason: values.reason,
      };

      try {
        const response = await UpdateInspectionStatusApi(payload, id);
        console.log("response of API:", response);
        setsnackBarData(response?.snackBarData);
        if (response?.success) {
          onDeny();
          if (payload?.status === "Cancelled") {
            navigate("/package/cancelled");
            dispatch(fetchInspectionData({ status: "Cancelled", page: 1, limit: 50 }));
          } else {
            navigate("/package/on-hold");
            dispatch(fetchInspectionData({ status: "OnHold", page: 1, limit: 50 }));
          }
          setLoading(false);
          toast.success("Status Update Successfully");
        } else {
          setLoading(false);
        }
      } catch (error) {
        console.error("API call error:", error);
        setLoading(false);
        onDeny();
      }
    },
  });
  console.log(formik.values);
  return (
    <Modal show={open} onHide={onDeny} centered>
      <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        <Modal.Header closeButton>
          <Modal.Title
            style={{
              fontSize: "17px",
              fontWeight: 600,
              lineHeight: 1.5,
              textAlign: "center",
            }}
            className="d-flex align-items-center justify-content-center gap-2"
          >
            Package Status Update
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate autoComplete="off" onSubmit={formik.handleSubmit}>
            <Form.Group controlId="status" className="mb-3">
              <Form.Label>Status</Form.Label>
              <Form.Select
                name="status"
                value={formik.values.status}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isInvalid={formik.touched.status && formik.errors.status}
              >
                <option value="">Select Status</option>
                <option value="Cancelled">Cancelled</option>
                {selectedRow?.status !== "OnHold" && (
                  <option value="OnHold">On Hold</option>
                )}
                {selectedRow?.status !== "Pending" && (
                  <option value="Pending">Pending</option>
                )}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {formik.errors.status}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="reason" className="mb-3">
              <Form.Label>Comment</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="reason"
                placeholder="Add a comment"
                value={formik.values.reason}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isInvalid={formik.touched.reason && formik.errors.reason}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.reason}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          {loading ? (
            <Spinner animation="border" />
          ) : (
            <>
              <Button
                variant="secondary"
                onClick={onDeny}
                style={{ flex: 1, fontWeight: 600 }}
              >
                No
              </Button>
              <Button
                variant="info"
                onClick={formik.handleSubmit} // Handle form submission
                style={{ flex: 1, fontWeight: 600 }}
              >
                Yes
              </Button>
            </>
          )}
        </Modal.Footer>
      </div>
    </Modal>
  );
};

UpdateStatusDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onDeny: PropTypes.func.isRequired,
  selectedRow: PropTypes.object,
};

export default UpdateStatusDialog;
